var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadBlack = function SvgDownloadBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.73 12.23.01 3a1.5 1.5 0 0 1-1.497 1.505l-10.5.03A1.5 1.5 0 0 1 3.24 15.27l-.009-3m6.724-9.02.025 8.625m0 0 3.74-3.76m-3.74 3.76-3.76-3.74"
  })));
};
export default SvgDownloadBlack;